import React from 'react';

import { motion } from 'framer-motion';

import { framerCommon } from '../../framer.variants';
import { data_assistance_banner } from './content';

export default function AssistanceBanner() {
  const { image, title, description } = data_assistance_banner;
  return (
    <div className="bg-gradient-to-b from-[#0092A8] to-[#17C583]">
      <div className="gl-wrapper flex items-center gap-[45px] sm:gap-4">
        <img className="relative -top-[8px] w-[6.625rem]" src={image} alt="" />
        <div>
          <div className="relative">
            <motion.p
              {...framerCommon}
              transition={{ duration: 0.5, delay: 0.75 }}
              whileInView="visible"
              variants={{
                hidden: { scale: 2.5, top: '1rem', marginLeft: '29%' },
                visible: {
                  scale: 1,
                  top: '0',
                  marginLeft: '0',
                },
              }}
              className="absolute font-Proxima text-subtitle font-black leading-tight text-white lg:hidden sm:text-[20px]"
            >
              {title}
            </motion.p>
            <p className="invisible min-h-[1.875rem] font-Proxima text-subtitle leading-tight text-white lg:visible sm:text-[20px]">
              {title}
            </p>
          </div>
          <motion.p
            {...framerCommon}
            transition={{ duration: 0.35, delay: 1.25 }}
            whileInView="visible"
            variants={{
              hidden: { bottom: '-1rem', opacity: 0 },
              visible: {
                bottom: '0',
                opacity: 1,
              },
            }}
            className="lg:!translate-[unset] relative overflow-hidden font-Proxima text-subtitle font-black leading-tight text-white lg:!bottom-0 lg:!h-full lg:!transform-none lg:!opacity-100 sm:text-[20px]"
          >
            {description}
          </motion.p>
        </div>
      </div>
    </div>
  );
}
